import { createContext } from 'react'

import type { PermissionsLocalized } from 'src/api/main'

export type WorkspacePermissionsContextType = {
  /**
   * The signed-in user's effective permissions for the resolved workspace
   * (`GET /organizations/permissions/user/`). `undefined` means "not resolved
   * yet" — distinguish it from an empty array, which means "resolved, and the
   * user has none".
   */
  permissions?: PermissionsLocalized[]
  isLoading: boolean
  /** The workspace the permissions were resolved for, if any. */
  workspaceId?: number
}

const initialWorkspacePermissionsContext: WorkspacePermissionsContextType = {
  permissions: undefined,
  isLoading: false,
  workspaceId: undefined
}

export const WorkspacePermissionsContext =
  createContext<WorkspacePermissionsContextType>(
    initialWorkspacePermissionsContext
  )
